import { useEffect, useState, useRef } from "react";
import axios from "axios";
import API_BASE_URL from "../config";

/* ─────────────────────────────────────────
   INJECT GLOBAL STYLES + MEDIA QUERIES
───────────────────────────────────────── */
const injectStyles = () => {
    if (document.getElementById("ann-global-styles")) return;
    const el = document.createElement("style");
    el.id = "ann-global-styles";
    el.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=Playfair+Display:wght@700;800&display=swap');

    @keyframes ann-overlay-in  { from { opacity: 0 } to { opacity: 1 } }
    @keyframes ann-overlay-out { from { opacity: 1 } to { opacity: 0 } }

    @keyframes ann-card-in {
      0%   { opacity: 0; transform: scale(0.97); }
      62%  { opacity: 1; transform: scale(1.005); }
      100% { opacity: 1; transform: scale(1); }
    }
    @keyframes ann-card-out {
      from { opacity: 1; transform: scale(1);    filter: blur(0); }
      to   { opacity: 0; transform: scale(1.03); filter: blur(6px); }
    }
    @keyframes ann-bar-in    { from { transform: scaleX(0) } to { transform: scaleX(1) } }
    @keyframes ann-fade-up   { from { opacity: 0; transform: translateY(14px) } to { opacity: 1; transform: translateY(0) } }
    @keyframes ann-img-in    { from { transform: scale(1.04); opacity: 0.6 } to { transform: scale(1); opacity: 1 } }
    @keyframes ann-dot-pulse { 0%,100% { transform: scale(1); opacity: 1 } 50% { transform: scale(1.7); opacity: 0.4 } }
    @keyframes ann-shimmer   { 0% { left: -110% } 100% { left: 210% } }
    @keyframes ann-float-0   { 0%{transform:translateY(0) scale(1);opacity:.9} 100%{transform:translateY(-90px) translateX(5px) scale(.2);opacity:0} }
    @keyframes ann-float-1   { 0%{transform:translateY(0) scale(1);opacity:.8} 100%{transform:translateY(-75px) translateX(-4px) scale(.15);opacity:0} }
    @keyframes ann-float-2   { 0%{transform:translateY(0) scale(1);opacity:.9} 100%{transform:translateY(-110px) translateX(7px) scale(.3);opacity:0} }
    @keyframes ann-float-3   { 0%{transform:translateY(0) scale(1);opacity:.7} 100%{transform:translateY(-65px) translateX(-5px) scale(.1);opacity:0} }
    @keyframes ann-float-4   { 0%{transform:translateY(0) scale(1);opacity:.9} 100%{transform:translateY(-95px) translateX(4px) scale(.25);opacity:0} }
    @keyframes ann-float-5   { 0%{transform:translateY(0) scale(1);opacity:.8} 100%{transform:translateY(-80px) translateX(-7px) scale(.2);opacity:0} }

    .ann-card-enter { animation: ann-card-in 0.55s cubic-bezier(0.22,1,0.36,1) forwards; }
    .ann-card-exit  { animation: ann-card-out 0.38s ease forwards !important; }

    .ann-s0 { animation: ann-fade-up 0.45s 0.25s ease both; }
    .ann-s1 { animation: ann-fade-up 0.45s 0.37s ease both; }
    .ann-s2 { animation: ann-fade-up 0.45s 0.47s ease both; }
    .ann-s3 { animation: ann-fade-up 0.45s 0.57s ease both; }
    .ann-s4 { animation: ann-fade-up 0.45s 0.65s ease both; }
    .ann-s5 { animation: ann-fade-up 0.45s 0.73s ease both; }

    .ann-bar      { animation: ann-bar-in 0.9s 0.2s cubic-bezier(0.22,1,0.36,1) both; transform-origin: left; }
    .ann-img-anim { animation: ann-img-in 0.7s 0.15s ease both; }

    .ann-close { transition: all 0.22s ease !important; }
    .ann-close:hover {
      background: rgba(212,175,55,0.22) !important;
      color: #d4af37 !important;
      border-color: rgba(212,175,55,0.5) !important;
      transform: rotate(90deg) scale(1.1) !important;
    }
    .ann-btn { transition: all 0.22s cubic-bezier(0.22,1,0.36,1) !important; }
    .ann-btn:hover {
      background: linear-gradient(135deg,#f5e07a,#d4af37,#b8922a) !important;
      box-shadow: 0 10px 36px rgba(212,175,55,0.55) !important;
      transform: translateY(-2px) scale(1.04) !important;
    }
    .ann-btn:active { transform: translateY(0) scale(0.97) !important; }

    /* ════════════════════════════════
       FULLSCREEN OVERLAY
    ════════════════════════════════ */
    .ann-overlay {
      position: fixed; inset: 0;
      background: #060d1a;
      display: flex;
      flex-direction: row;
      z-index: 9999;
      padding: 0;
      box-sizing: border-box;
      overflow: hidden;
    }

    /* ════════════════════════════════
       FULLSCREEN CARD (fills overlay)
    ════════════════════════════════ */
    .ann-card {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;       /* ← side-by-side on desktop */
      background: linear-gradient(135deg,#0b1a30 0%,#07101f 50%,#060d1a 100%);
      border-radius: 0;
      overflow: hidden;
      position: relative;
      font-family: 'Sora', sans-serif;
    }

    /* ════════════════════════════════
       LEFT PANEL — image fills full height
    ════════════════════════════════ */
    .ann-img-section {
      width: 52%;
      height: 100%;
      flex-shrink: 0;
      position: relative;
      overflow: hidden;
      background: #ffffff;
    }
    .ann-img-el {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center center;
      display: block;
    }

    /* ════════════════════════════════
       RIGHT PANEL — scrollable content
    ════════════════════════════════ */
    .ann-right-panel {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      min-width: 0;
      overflow: hidden;
    }

    /* Scrollable body */
    .ann-body {
      flex: 1 1 auto;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 60px 56px 28px;
      scrollbar-width: thin;
      scrollbar-color: rgba(212,175,55,0.2) transparent;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .ann-body::-webkit-scrollbar       { width: 4px; }
    .ann-body::-webkit-scrollbar-track { background: transparent; }
    .ann-body::-webkit-scrollbar-thumb { background: rgba(212,175,55,0.25); border-radius: 4px; }

    /* Sticky footer */
    .ann-footer {
      flex-shrink: 0;
      padding: 18px 56px 28px;
      border-top: 1px solid rgba(255,255,255,0.06);
      background: rgba(255,255,255,0.015);
      display: flex; align-items: center; justify-content: space-between;
      gap: 12px;
    }

    .ann-meta-row {
      display: flex; align-items: center;
      gap: 10px; flex-wrap: wrap; margin-bottom: 20px;
    }
    .ann-title {
      font-family: 'Playfair Display', serif;
      font-size: clamp(28px, 3.5vw, 48px);
      font-weight: 800;
      color: #f3e9cc; margin: 0 0 18px;
      line-height: 1.2; letter-spacing: -0.02em;
      text-shadow: 0 4px 32px rgba(212,175,55,0.18);
    }
    .ann-message {
      font-size: clamp(13px, 1.1vw, 16px);
      font-weight: 300;
      color: rgba(195,215,245,0.82);
      line-height: 1.8; margin: 0 0 24px;
      max-width: 520px;
    }
    .ann-date-chip {
      display: inline-flex; align-items: center; gap: 8px;
      background: rgba(255,255,255,0.04);
      border: 1px solid rgba(255,255,255,0.08);
      border-radius: 10px; padding: 8px 16px;
      font-size: 12px; font-weight: 400;
      color: rgba(175,195,230,0.55); letter-spacing: 0.03em;
    }
    .ann-footer-left  { display: flex; align-items: center; gap: 8px; }
    .ann-footer-note  { font-size: 11px; color: rgba(165,185,225,0.3); letter-spacing: 0.05em; }
    .ann-dismiss-btn  {
      background: linear-gradient(135deg,#c29020,#d4af37 45%,#e8c84a);
      color: #06100e; border: none; border-radius: 14px;
      padding: 14px 40px; font-size: 14px; font-weight: 700;
      cursor: pointer; letter-spacing: 0.04em;
      font-family: 'Sora', sans-serif; white-space: nowrap;
      box-shadow: 0 6px 28px rgba(212,175,55,0.42), inset 0 1px 0 rgba(255,255,255,0.28);
    }

    /* ── TABLET  ≤ 900px — stack vertically ── */
    @media (max-width: 900px) {
      .ann-card        { flex-direction: column; }
      .ann-img-section { width: 100%; height: 42vh; flex-shrink: 0; }
      .ann-right-panel { flex: 1 1 auto; overflow: hidden; }
      .ann-body        { padding: 32px 36px 20px; justify-content: flex-start; }
      .ann-footer      { padding: 14px 36px 24px; }
      .ann-title       { font-size: clamp(22px, 4vw, 32px); }
      .ann-message     { font-size: 13.5px; }
    }

    /* ── MOBILE  ≤ 600px ── */
    @media (max-width: 600px) {
      .ann-img-section { height: 36vh; }
      .ann-body        { padding: 24px 22px 16px; }
      .ann-footer      { padding: 12px 22px 28px; flex-direction: column; align-items: stretch; gap: 10px; }
      .ann-footer-left { justify-content: center; }
      .ann-footer-note { text-align: center; }
      .ann-dismiss-btn { width: 100%; text-align: center; padding: 15px 0; font-size: 14px; border-radius: 12px; }
      .ann-title       { font-size: clamp(20px, 5.5vw, 26px); margin-bottom: 12px; }
      .ann-message     { font-size: 13px; line-height: 1.7; margin-bottom: 16px; }
      .ann-meta-row    { gap: 7px; margin-bottom: 12px; }
    }

    /* ── SMALL MOBILE  ≤ 400px ── */
    @media (max-width: 400px) {
      .ann-img-section { height: 30vh; }
      .ann-body        { padding: 18px 16px 14px; }
      .ann-title       { font-size: 19px; }
    }
  `;
    document.head.appendChild(el);
};

/* ─────────────────────────────────────────
   AUTH IMAGE
───────────────────────────────────────── */
function AuthImage({ src }) {
    const [blobUrl, setBlobUrl] = useState(null);
    const prevUrl = useRef(null);

    useEffect(() => {
        if (!src) return;
        if (prevUrl.current) URL.revokeObjectURL(prevUrl.current);
        let cancelled = false;
        const token = localStorage.getItem("token");
        fetch(src, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
            .then(r => { if (!r.ok) throw new Error(); return r.blob(); })
            .then(blob => {
                if (cancelled) return;
                const url = URL.createObjectURL(blob);
                prevUrl.current = url;
                setBlobUrl(url);
            })
            .catch(() => setBlobUrl(null));
        return () => { cancelled = true; };
    }, [src]);

    if (!blobUrl) return (
        <div style={{
            width: "100%", height: "100%",
            display: "flex", alignItems: "center", justifyContent: "center",
            background: "#f8f9fa",
        }}>
            <span style={{ fontSize: 72, opacity: 0.15 }}>🖼</span>
        </div>
    );

    return <img src={blobUrl} className="ann-img-el ann-img-anim" alt="" />;
}

/* ─────────────────────────────────────────
   FLOATING PARTICLES
───────────────────────────────────────── */
const PARTICLES = [
    { left: "10%", bottom: "4px", size: 6, color: "#c9972a", delay: "0s",   dur: "2.9s" },
    { left: "24%", bottom: "2px", size: 4, color: "#d4af37", delay: "0.5s", dur: "2.4s" },
    { left: "43%", bottom: "7px", size: 7, color: "#c9972a", delay: "0.9s", dur: "3.1s" },
    { left: "61%", bottom: "3px", size: 4, color: "#7faee0", delay: "0.3s", dur: "2.7s" },
    { left: "78%", bottom: "5px", size: 5, color: "#c9972a", delay: "1.1s", dur: "2.9s" },
    { left: "91%", bottom: "6px", size: 4, color: "#d4af37", delay: "0.7s", dur: "2.5s" },
];
function Particles() {
    return PARTICLES.map((p, i) => (
        <div key={i} style={{
            position: "absolute", left: p.left, bottom: p.bottom,
            width: p.size, height: p.size, borderRadius: "50%",
            background: p.color,
            boxShadow: `0 0 ${p.size * 2}px ${p.color}99`,
            animation: `ann-float-${i} ${p.dur} ${p.delay} ease-out infinite`,
            pointerEvents: "none",
        }} />
    ));
}

/* ─────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────── */
export default function AnnouncementPopup() {
    const [announcement, setAnnouncement] = useState(null);
    const [phase, setPhase] = useState("idle");
    const employeeId = localStorage.getItem("employeeId");

    useEffect(() => { injectStyles(); }, []);

    const authHeaders = () => {
        const token = localStorage.getItem("token");
        return token ? { Authorization: `Bearer ${token}` } : {};
    };

    useEffect(() => {
        const check = async () => {
            try {
                const res = await axios.get(
                    `${API_BASE_URL}/api/announcements/active?employeeId=${employeeId}`,
                    { headers: authHeaders() }
                );
                if (res.data.length > 0) {
                    setAnnouncement(res.data[0]);
                    setPhase("visible");
                }
            } catch (_) {}
        };
        check();
        const id = setInterval(check, 30000);
        return () => clearInterval(id);
    }, []);

    const handleDismiss = async () => {
        setPhase("exiting");
        try {
            await axios.post(
                `${API_BASE_URL}/api/announcements/dismiss`,
                { announcementId: announcement.id, employeeId },
                { headers: authHeaders() }
            );
        } catch (_) {}
        setTimeout(() => { setAnnouncement(null); setPhase("idle"); }, 420);
    };

    if (!announcement || phase === "idle") return null;

    return (
        <div
            className="ann-overlay"
            style={{
                animation: phase === "exiting"
                    ? "ann-overlay-out 0.38s ease forwards"
                    : "ann-overlay-in 0.28s ease",
            }}
        >
            {/* Ambient orbs */}
            <div style={IS.orb1} />
            <div style={IS.orb2} />
            <div style={IS.orb3} />

            <div className={`ann-card ${phase === "exiting" ? "ann-card-exit" : "ann-card-enter"}`}>

                {/* Gold top bar — spans full width */}
                <div style={IS.topBarTrack}>
                    <div className="ann-bar" style={IS.topBar} />
                </div>

                {/* Close button */}
                <button className="ann-close" style={IS.closeBtn} onClick={handleDismiss}>✕</button>

                {/* ══════════════════════════════════════
                    LEFT — IMAGE PANEL (full height)
                ══════════════════════════════════════ */}
                <div className="ann-img-section">
                    <AuthImage
                        src={announcement.templateUrl
                            ? `${API_BASE_URL}${announcement.templateUrl}`
                            : null}
                    />

                    {/* Right-edge fade: image bleeds into right panel */}
                    <div style={IS.imgFadeRight} />

                    {/* Bottom fade for mobile stacked layout */}
                    <div style={IS.imgFadeBottom} />

                    {/* Shimmer sweep */}
                    <div style={IS.shimmer} />

                    {/* LIVE badge */}
                    <div style={IS.liveBadge} className="ann-s0">
                        <span style={IS.liveDot} />
                        LIVE NOW
                    </div>

                    {/* Rising particles */}
                    <div style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden" }}>
                        <Particles />
                    </div>
                </div>

                {/* ══════════════════════════════════════
                    RIGHT — CONTENT PANEL
                ══════════════════════════════════════ */}
                <div className="ann-right-panel">

                    {/* Scrollable body */}
                    <div className="ann-body">

                        {/* Decorative top accent line */}
                        <div style={IS.accentLine} className="ann-s0" />

                        <div className="ann-meta-row ann-s1">
                            <span style={IS.badge}>
                                <span>📣</span> Announcement
                            </span>
                        </div>

                        <h2 className="ann-title ann-s2">{announcement.title}</h2>

                        <div style={IS.rule} className="ann-s2" />

                        <p className="ann-message ann-s3">{announcement.message}</p>

                        <div className="ann-date-chip ann-s4">
                            <span>📅</span>
                            {new Date(announcement.date).toLocaleDateString("en-US", {
                                weekday: "long", month: "long", day: "numeric",
                            })}
                        </div>
                    </div>

                    {/* Sticky footer */}
                    <div className="ann-footer ann-s5">
                        <div className="ann-footer-left">
                            <span style={IS.footerDot} />
                            <span className="ann-footer-note"></span>
                        </div>
                        <button className="ann-btn ann-dismiss-btn" onClick={handleDismiss}>
                            Got it &nbsp;👍
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
}

/* ─────────────────────────────────────────
   STATIC INLINE STYLES
───────────────────────────────────────── */
const IS = {
    orb1: {
        position: "absolute", pointerEvents: "none",
        width: 800, height: 800, borderRadius: "50%",
        background: "radial-gradient(circle,rgba(212,175,55,0.08) 0%,transparent 65%)",
        top: "-20%", right: "10%",
    },
    orb2: {
        position: "absolute", pointerEvents: "none",
        width: 500, height: 500, borderRadius: "50%",
        background: "radial-gradient(circle,rgba(80,120,215,0.07) 0%,transparent 65%)",
        bottom: "0%", right: "5%",
    },
    orb3: {
        position: "absolute", pointerEvents: "none",
        width: 400, height: 400, borderRadius: "50%",
        background: "radial-gradient(circle,rgba(212,175,55,0.06) 0%,transparent 65%)",
        bottom: "10%", left: "55%",
    },

    topBarTrack: {
        position: "absolute", top: 0, left: 0, right: 0,
        height: 4, background: "rgba(255,255,255,0.03)",
        zIndex: 30, flexShrink: 0,
    },
    topBar: {
        height: "100%",
        background: "linear-gradient(90deg,#7a5c10,#d4af37 30%,#f5e07a 52%,#d4af37 72%,#7a5c10)",
        boxShadow: "0 0 20px rgba(212,175,55,0.7)",
    },

    closeBtn: {
        position: "absolute", top: 18, right: 18, zIndex: 40,
        width: 38, height: 38, borderRadius: "50%",
        border: "1px solid rgba(255,255,255,0.15)",
        background: "rgba(255,255,255,0.08)",
        color: "rgba(255,255,255,0.6)",
        cursor: "pointer", fontSize: 12,
        display: "flex", alignItems: "center", justifyContent: "center",
        backdropFilter: "blur(8px)",
    },

    /* Right-edge fade: blends image into dark right panel */
    imgFadeRight: {
        position: "absolute", top: 0, right: 0, bottom: 0,
        width: "30%",
        background: "linear-gradient(to right, transparent 0%, rgba(7,16,31,0.85) 100%)",
        pointerEvents: "none",
    },

    /* Bottom fade: only visible on mobile stacked layout */
    imgFadeBottom: {
        position: "absolute", bottom: 0, left: 0, right: 0,
        height: "40%",
        background: "linear-gradient(to bottom, transparent 0%, rgba(7,16,31,0.95) 100%)",
        pointerEvents: "none",
    },

    shimmer: {
        position: "absolute", top: 0, bottom: 0, width: "42%",
        background: "linear-gradient(110deg,transparent 25%,rgba(255,255,255,0.25) 50%,transparent 75%)",
        animation: "ann-shimmer 5s 0.5s ease-in-out infinite",
        pointerEvents: "none",
    },

    liveBadge: {
        position: "absolute", top: 18, left: 18,
        display: "flex", alignItems: "center", gap: 6,
        background: "rgba(255,255,255,0.88)",
        border: "1px solid rgba(212,175,55,0.5)",
        backdropFilter: "blur(8px)",
        color: "#9a6e00", fontSize: 10, fontWeight: 700, letterSpacing: "0.18em",
        padding: "6px 14px", borderRadius: 30,
        fontFamily: "'Sora',sans-serif",
        boxShadow: "0 2px 14px rgba(0,0,0,0.12)",
        zIndex: 10,
    },
    liveDot: {
        display: "inline-block", width: 7, height: 7, borderRadius: "50%",
        background: "#d4af37", boxShadow: "0 0 8px rgba(212,175,55,0.9)",
        animation: "ann-dot-pulse 1.4s ease-in-out infinite",
    },

    accentLine: {
        width: 48, height: 3, borderRadius: 2,
        background: "linear-gradient(90deg,#d4af37,#f5e07a)",
        marginBottom: 28,
        boxShadow: "0 0 12px rgba(212,175,55,0.5)",
    },

    badge: {
        display: "inline-flex", alignItems: "center", gap: 6,
        background: "linear-gradient(135deg,rgba(212,175,55,0.18),rgba(212,175,55,0.06))",
        border: "1px solid rgba(212,175,55,0.35)",
        color: "#d4af37", fontSize: 11, fontWeight: 600, letterSpacing: "0.06em",
        padding: "6px 14px", borderRadius: 30,
    },

    rule: {
        height: 1,
        background: "linear-gradient(90deg,rgba(212,175,55,0.45),rgba(212,175,55,0.08) 65%,transparent)",
        marginBottom: 20,
    },

    footerDot: {
        display: "inline-block", flexShrink: 0,
        width: 8, height: 8, borderRadius: "50%",
        background: "#d4af37", boxShadow: "0 0 8px rgba(212,175,55,0.6)",
        animation: "ann-dot-pulse 2s ease-in-out infinite",
    },
};